import React, { PropsWithChildren } from 'react';

interface StepTabProps {
  step: number;
}

export function StepTab({ step, children }: PropsWithChildren<StepTabProps>) {
  return <div key={step}>{children}</div>;
}
